import { render } from "./UserData.vue?vue&type=template&id=15c7f765"
import script from "./UserData.vue?vue&type=script&lang=js"
export * from "./UserData.vue?vue&type=script&lang=js"

import "./UserData.vue?vue&type=style&index=0&id=15c7f765&lang=css"

import exportComponent from "C:\\laragon\\www\\runpixie_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSkeleton,QForm,QInput,QSelect,QBtn});
